var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 90",
    style: {
      enableBackground: "new 0 0 125 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.dynamic{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dynamic",
    d: "M12.4,1.8C7.3,2.9,3.6,6.7,2.4,12c-0.5,2.3-0.6,2.9-0.1,5.1c1.6,8.1,9.5,12.9,17.2,10.3c3.9-1.3,6.3-3.5,8-7 C31.9,10.4,23.1-0.6,12.4,1.8z M77.8,9.3c-1.9,0.7-5,2.1-10.2,4.6c-16,7.8-15.3,7.6-26.6,9.7c-3.2,0.6-6.8,1.4-8,1.6 c-1.2,0.3-2.8,0.6-3.5,0.8c-0.7,0.1-2.7,0.8-4.4,1.5c-2.3,1-3.4,1.7-4.5,2.9c-2.7,3.1-4,8.3-3.1,12.5c0.7,3.3,2.4,6.3,6.5,11.4 c2.2,2.7,4.6,5.7,5.4,6.7c1.6,2.1,6.8,8.7,13.6,17.4c6.4,8.2,9.3,10,15.8,10c4.9,0,8.7-1.7,12.5-5.4c3.5-3.4,10.1-9.8,13.9-13.3 c6.8-6.4,6.6-6.2,19.9-14.6c2.5-1.5,6-3.8,8-5c5.2-3.2,7.5-4.7,8.2-5.4c2.9-2.8,2.2-8.4-1.3-10.2c-2.6-1.4-4.6-1-10.3,1.8 c-2.8,1.4-5.3,2.6-5.6,2.8c-0.3,0.2-1.4,0.8-2.5,1.3c-19.9,9.8-19.8,9.7-27.8,15.9c-2,1.6-4.6,3.5-5.8,4.4l-2.1,1.6l-5.3-6.7 c-2.9-3.7-7.1-9-9.3-11.8c-5.6-7-6.2-8-5.9-8.3c0.2-0.1,2.5-0.7,5.3-1.3c5.4-1.1,7-1.8,17.5-6.8c3.4-1.6,8.1-3.9,10.4-5 c5.8-2.8,7.1-4.4,6.5-8.3c-0.2-1.6-1.6-3.5-3-4.2C81.1,9.4,78.5,9.1,77.8,9.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilates);
export default __webpack_public_path__ + "static/media/pilates.f5dbd16af9a4de775664f54377b54382.svg";
export { ForwardRef as ReactComponent };